<template>
  <div class="box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="has-text-weight-bold">
      Atuação
    </h2>
    <br />

    <!-- Realiza projetos? -->
    <b-field label="Sua OE realiza projetos?">
      <div class="block">
        <b-radio
          v-model="oe.hasProjects"
          name="oe.hasProjects"
          :native-value="true"
        >
          Sim
        </b-radio>

        <b-radio
          v-model="oe.hasProjects"
          name="oe.hasProjects"
          :native-value="false"
        >
          Não
        </b-radio>
      </div>
    </b-field>

    <!-- OE - Projetos -->
    <b-field
      :label="
        oe.projects
          ? 'Descreva brevemente os principais projetos da sua OE'
          : ''
      "
      label-position="on-border"
      v-show="oe.hasProjects"
    >
      <b-input
        v-model="oe.projects"
        placeholder="Descreva brevemente os principais projetos da sua OE..."
        maxlength="1500"
        type="textarea"
        rows="5"
      ></b-input>
    </b-field>

    <!-- Realiza eventos? -->
    <b-field label="Sua OE realiza eventos?">
      <div class="block">
        <b-radio
          v-model="oe.hasEvents"
          name="oe.hasEvents"
          :native-value="true"
        >
          Sim
        </b-radio>

        <b-radio
          v-model="oe.hasEvents"
          name="oe.hasEvents"
          :native-value="false"
        >
          Não
        </b-radio>
      </div>
    </b-field>

    <!-- OE - Eventos -->
    <b-field
      :label="
        oe.events ? 'Descreva brevemente os principais eventos da sua OE' : ''
      "
      label-position="on-border"
      v-show="oe.hasEvents"
    >
      <b-input
        v-model="oe.events"
        placeholder="Sua OE será responsável pela organização de algum evento nos próximos 12 meses em que tenha interesse de encaixar a palestra de uma Empresa Mentora?"
        maxlength="1500"
        type="textarea"
        rows="5"
      ></b-input>
    </b-field>

    <Pendencies :pendencies="pendencies" />

    <div>
      <button
        class="button is-primary is-rounded"
        style="margin-left: auto; display: block;"
        @click="updateOrganization"
        :disabled="pendencies.length > 0"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import Pendencies from "../../commom/Pendencies.vue";

export default {
  name: "FormActing",

  props: ["oe"],

  components: {
    Pendencies
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    updateOrganization() {
      this.isLoading = true;

      if (!this.oe.hasProjects) {
        this.oe.projects = "";
      }

      if (!this.oe.hasEvents) {
        this.oe.events = "";
      }

      this.$store
        .dispatch("updateOrganization", {
          oe: this.oe
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.showOrganizationEmailInput = false;
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "As informações das ações da OE foram atualizadas 😉",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
            if (this.oe.fanpage) {
              this.oeHasFanpage = true;
              if (this.oe.fanpage.indexOf("https") === -1) {
                this.oe.fanpage = "https://www.facebook.com/" + this.oe.fanpage;
              }
            }
            if (this.oe.insta) {
              this.oeHasInsta = true;
              if (this.oe.insta.indexOf("https") === -1) {
                this.oe.insta = "https://www.instagram.com/" + this.oe.insta;
              }
            }
            if (this.oe.linkedin) {
              this.oeHasLinkedin = true;
              if (this.oe.linkedin.indexOf("https") === -1) {
                this.oe.linkedin =
                  "https://www.linkedin.com/company/" + this.oe.linkedin;
              }
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    pendencies() {
      const pendencies = [];

      if (this.oe.hasProjects && this.oe.projects == "") {
        pendencies.push("Descrição do(s) tipo(s) de projeto(s)");
      }

      if (this.oe.hasEvents && this.oe.events == "") {
        pendencies.push("Descrição do(s) tipo(s) de evento(s)");
      }

      return pendencies;
    }
  }
};
</script>

<style scoped>
.box {
  padding: 2rem 3rem;
  max-width: 800px !important;
  margin: auto;
}
@media (max-width: 400px) {
  .box {
    padding: 0.5rem !important;
  }
}
</style>
